module.exports = __webpack_public_path__ + "static/media/curtain-wall-spraying-001-thumbnail.77fc8feb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/thumbnails/curtain-wall-spraying-001-thumbnail.jpg
// module id = 106
// module chunks = 0